// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2xetX","additionalInfo":"AgreementModal_additionalInfo__182Xb"};